var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-sm connect-with",attrs:{"title":_vm.__('connect_with'),"disabled":_vm.disabled},on:{"click":_vm.showModal}},[_c('i',{staticClass:"far fa-clone"}),_vm._v(" "+_vm._s(_vm.__('connect_with'))+" \n")])}
var staticRenderFns = []

export { render, staticRenderFns }